import * as validators from '@vuelidate/validators'
import i18n from '@/libs/i18n'

const { createI18nMessage } = validators
const withI18nMessage = createI18nMessage({ t: i18n.t.bind(i18n) })

export const requiredValidate = withI18nMessage(validators.required)
export const maxValidate = withI18nMessage(validators.maxLength, { withArguments: true })
export const emailValidate = withI18nMessage(validators.email)
export const numericValidate = withI18nMessage(validators.numeric)
export const urlValidate = withI18nMessage(validators.url)
